import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const UnfoldButton = styled.span`
  display: flex;
  align-items: center;
  margin: 0;
  padding: ${({ theme }) => theme.spacing(0.5)};

  border: none;
  border-radius: ${({ theme }) => theme.spacing(1.5)};
  background: none;
  cursor: pointer;
  transition: background 200ms;

  color: ${({ theme }) => theme.palette.grey[700]};

  &:hover {
    background: ${({ theme }) => theme.palette.grey[100]};
  }
`;

export const Container = styled.article<{
  $isDragging: boolean;
  $isMoving: boolean;
}>`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};

  margin: ${({ theme }) =>
    `${theme.spacing(4)} ${theme.spacing(6)} ${theme.spacing(1)}`};
  padding: ${({ theme }) => `${theme.spacing(2)} 0`};

  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};

  ${({ $isDragging, $isMoving }) =>
    ($isDragging || $isMoving) &&
    css`
      ${UnfoldButton} {
        display: none;
      }
    `};
`;

export const UnfoldIconContainer = styled.span<{ $open: boolean }>`
  display: block;

  transform: ${({ $open }) => `rotate(${$open ? -90 : 0}deg)`};
  transition: transform 200ms;

  font-size: 1.4rem;
  line-height: 62.5%;
`;

export const Body = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(0.5)};

  ${({ theme }) =>
    theme.isMobile &&
    css`
      justify-content: flex-start;
    `};
`;

export const Content = styled.div`
  ${({ theme }) => typographyToCss(theme.typography.subtitle2)};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const OtherSectionTitle = styled.span``;

export const TaskCount = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const IconButtonContainer = styled.div`
  color: ${({ theme }) => theme.palette.grey[600]};
`;
